import store from '../store'
import map from "./map";
Date.prototype.format = function (splitString, date) {
    let split = splitString ? splitString : '-'
    date = date ? new Date(date) : new Date()
    let year = date.getFullYear()
    let month = date.getMonth() - 1
    let day = date.getDate()
    return `${year}${split}${month > 9 ? month : '0' + month}${split}${day > 9 ? day : '0' + day}`
}

export default {
    map,
    // 数字格式化-每三位加逗号
    toThousands(num) {
        var result = [ ], counter = 0;
        num = (num || 0).toString().split('');
        for (var i = num.length - 1; i >= 0; i--) {
            counter++;
            result.unshift(num[i]);
            if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        return result.join('');
    },
    checkHsCode(data) {
        return true
        // if(store.getters.user.hsCodes){
        //   let stringLength = data.length
        //   let right = store.getters.user.hsCodes.find(item => {
        //     let codes = item.hsCodes.split(',')
        //     let rightCode = codes.find(c => {
        //       let length = Math.min(c.length, stringLength)
        //       return c.slice(0, length) === data.slice(0, length)
        //     })
        //     return !!rightCode
        //   })
        //   return !!right
        // } else {
        //   return true
        // }
    },
    //获得当前浏览器默认使用的语言
    getCurrentBrowseLanguage() {
        if (this.judgeOrigin() === "TR") {
            let lang = "en"
            return lang
        } else {
            const navLang = navigator.language || navigator.userLanguage
            let localLang = navLang || false
            let lang = (localLang || localRead('local') || 'enUS').toLocaleLowerCase()
            return lang === "zh-cn" || lang.indexOf('cn') >= 0 || lang.indexOf('zh') >= 0 ? "zh" : "en";
        }
    },
    loginOutUrl(retrunUrl) {
        //清楚所有缓存
        // window.localStorage.clear()
        // window.sessionStorage.clear()
        console.log(localStorage.getItem("accessToken"), 'accesstoken');
        if (retrunUrl.toLowerCase().indexOf('/login') >= 0) {
            retrunUrl = "/dashboard";
        }
        // https://demo.topease.net/login/login?product=gt5
        let gotoPageUrl = this.getLoginUrl() + `&redirect=${encodeURIComponent(decodeURIComponent(retrunUrl))}`
        window.location.href = gotoPageUrl
        // console.log(gotoPageUrl)
    },
    //是否是测试环境
    isTest() {
        let dnsList = ['demo.topease.net', 'trdev.topease.net', 'dev.topease.net']
        return dnsList.includes(this.getCurrentDomain());
        // return this.getCurrentWebSiteByProduct().indexOf("demo.topease.net") >= 0;
        //true or false
    },
    // 判断是否是本地
    isLocal() {
        return this.getCurrentDomain().indexOf('localhost') >= 0
    },
    //获得当前二级网址，具体到哪一个产品
    getCurrentWebSiteByProduct() {
        if (location.href.toLocaleLowerCase().indexOf("localhost") >= 0) {
            return 'http://localhost:8089' + "/" + this.getCurrentProductName();
        } else {
            return this.getCurrentWebSite() + "/" + this.getCurrentProductName();
        }

        //eg:https://et.topease.net/gt5
    },
    //获得当前二级网址(不是顶级域名)
    getCurrentWebSite() {
        if (location.href.toLocaleLowerCase().indexOf("localhost") >= 0) {
            return 'https://demo.topease.net'
        } else {
            return (location.href.toLocaleLowerCase().indexOf("https://") >= 0 ? "https://" : "http://") + this.getCurrentDomain()
        }
        //eg:https://et.topeaes.net
    },
    //获得当前网址的域名
    getCurrentDomain() {
        return location.hostname
        //eg:et.topease.net
    },
    //获得当前产品的标识符
    getCurrentProductName() {
        return location.href.toLowerCase().replace("http://", "").replace("https://", "").split('/')[1]
        //eg:gt5
    },
    //获取当前页面的pageUnionID
    getPageUnionID(pageUnionID) {
        let index = location.href.lastIndexOf("gt6")
        let currentUrlString = location.href.substring(index, location.href.length)
        //判断当前字符串是有参数
        if (currentUrlString.includes('?')) {
            let currentUrlStringInx = currentUrlString.indexOf('?')
            let currentUrlStringChild = currentUrlString.substring(0, currentUrlStringInx)
            return this.splitString(currentUrlStringChild)
        } else {
            return this.splitString(currentUrlString)

        }
    },
    // 截取字符串
    splitString(string) {
        let currentUrlArr = string.split('/')
        if (currentUrlArr.length >= 3) {
            return currentUrlArr[0] + '_' + currentUrlArr[1] + '_' + currentUrlArr[2]
        } else {
            return currentUrlArr[0] + '_' + currentUrlArr[1]
        }
    },
    //获得跳转登录地址
    getLoginUrl() {
        if (location.href.toLocaleLowerCase().indexOf("localhost") >= 0) {
            return 'http://localhost' + ':8089' + "/#/login?product=" + this.getCurrentProductName()
        } else {
            return this.getCurrentWebSite() + "/login?product=" + this.getCurrentProductName()
        }
        //eg:https://et.topease.net/login?product=gt5
    },
    //是否是登录状态
    isLogin() {
        return (localStorage.getItem("accessToken") != null && localStorage.getItem("accessToken").length > 5);
    },
    // 校验输入内容全部是特殊字符
    matchSpecialChart(val) {
        return val.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').length
    },
    judgeOrigin() {
        // 线上环境，dev环境，demo环境
        let TrArr = ["export.itoponemail.com", "export.bilvio.com", "trdev.topease.net", "trdemo.topease.net"] //土耳其
        let EcArr = ["ecd.ec.com.cn", "ec.topease.net", "ec1.topease.net"] // EC
        let JmArr = ["jmecd.ec.com.cn","jmecd.topease.net", "jm.topease.net", "jm1.topease.net"] // JM
        let JmSaleArr = ["devecd.topease.net","demoecd.topease.net","ecd.topease.net"] // JmSale
        let DFArr = ['localhost']
        if (TrArr.includes(this.getCurrentDomain())) {
            return 'TR' //土耳其
        } else if (EcArr.includes(this.getCurrentDomain())) {
            return 'EC'//ec  登录
        } else if (DFArr.includes(this.getCurrentDomain())) {
            return 'DF'//ec  登录本地调试 可以修改当前的值
        } else if (JmSaleArr.includes(this.getCurrentDomain())) {
            return 'EC'//JM  登录
        } else if (JmArr.includes(this.getCurrentDomain())) {
            return 'JM'//JM  登录
        } else {
            return 'DF'//默认 登录
        }
    },
    // 返回产品名
    getProducts() {
        let products = JSON.parse(localStorage.getItem('gt6_getRules')) ? JSON.parse(localStorage.getItem('gt6_getRules')).products : store.getters.getGT6RulesUser.products
        let yisou = products.findIndex(item => item.key == 'yisou3')
        return yisou >= 0
    },
    // 调整表格样式，双行时展示tooltip
    onMouseOver(e, text) {
        let parent = document.querySelector(".tableShowLine2")
        if (!parent) return true
        let TemporaryTag = document.createElement('span');
        TemporaryTag.innerText = text;
        TemporaryTag.style.fontSize = "14px";
        TemporaryTag.className = 'getTextWidth';
        document.querySelector('body').appendChild(TemporaryTag);
        let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
        document.querySelector('.getTextWidth').remove();
        /*cellWidth为表格容器的宽度*/
        const cellWidth = e.target.offsetWidth
        /*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
        return currentWidth <= ((2 * cellWidth - 4))
    },
    // 处理商品描述去掉翻译按钮的tooltip展示
    onMouseOverLins1(e, text, className, tableCss) {
        let parent = document.querySelector(`.${className}`)
        if(!parent) return true
        let TemporaryTag = document.createElement('span');
        TemporaryTag.innerText = text;
        TemporaryTag.style.fontSize = "14px";
        TemporaryTag.className = 'getTextWidth';
        document.querySelector('body').appendChild(TemporaryTag);
        let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
        document.querySelector('.getTextWidth').remove();
        /*cellWidth为表格容器的宽度*/
        const cellWidth = e.target.offsetWidth
        if(tableCss>2) return true
        /*当文本宽度小于||等于容器宽度两倍/一行时，代表文本显示未超过两行*/
        return currentWidth <= ((tableCss*cellWidth-4))
    },
    // 添加千分位
    formatThousand(money) {  
        let res = money.toString().replace(/\d+/, function(num){ // 先提取整数部分
            return num.replace(/(\d)(?=(\d{3})+$)/g, function($1){
            return $1+",";
            });
        })
        return res;
    },
    moneyShow(data) {
        data = 1*data
        data = data || 0
        return this.formatThousand(data)
    },
    // 处理Y轴单位转换
    formatterAxix(value) {
        let data = Math.abs(value)
        if (data >= 100000000) {
            return value / 100000000 + "亿";
        } else if (data >= 10000000) {
            return value / 10000000 + "千万";
        } else if (data >= 1000000) {
            return value / 1000000 + "百万";
        } else if (data >= 100000) {
            return value / 100000 + "十万";
        } else if (data >= 10000) {
            return value / 10000 + "万";
        } else if (data >= 1000) {
            return value / 1000 + "千";
        } else {
            return value;
        }
    },
      // 处理Y轴单位转换英文
    formatterAxixEn(value) {
        let data = Math.abs(value)
        if (data >= 1000000000) {
            return value / 1000000000 + "b";
        } else if (data >= 10000000) {
            return value / 1000000 + "m";
        } else if (data >= 1000) {
            return value / 1000 + "k";
        } else {
            return value;
        }
    },
    // 处理Treemap单位且保留2位小数转换
    formatterTreemap(value) {
        let data = Math.abs(value)
        if (data >= 100000000) {
            value = value / 100000000
            return value.toFixed(2) + "亿";
        } else if (data >= 10000000) {
            value = value / 10000000
            return value.toFixed(2) + "千万";
        } else if (data >= 1000000) {
            value = value / 1000000
            return value.toFixed(2)  + "百万";
        } else if (data >= 100000) {
            value = value / 100000
            return value.toFixed(2) + "十万";
        } else if (data >= 10000) {
            value = value / 10000
            return value.toFixed(2) + "万";
        } else if (data >= 1000) {
            value = value / 1000
            return value.toFixed(2) + "千";
        } else {
            return value;
        }
    },
      // 处理Y轴单位转换英文
    formatterTreemapEn(value) {
        let data = Math.abs(value)
        if (data >= 1000000000) {
            value = value / 1000000000
            return value.toFixed(2) + "b";
        } else if (data >= 10000000) {
            value = value / 1000000
            return value.toFixed(2) + "m";
        } else if (data >= 1000) {
            value = value / 1000
            return value.toFixed(2) + "k";
        } else {
            return value;
        }
    },
    // 生成GUID
    S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    getGuid() {
        return this.S4() + this.S4() +'-' +this.S4() +'-' +this.S4() +'-' +this.S4() +'-' +this.S4() +this.S4() +this.S4();
    },
    // 获取近七天日期
    getDays(day) {
        day = day ?? 7
        const moment = require('moment')
        return [moment().subtract(day-1, "days").format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    },
    // 查询参数
    getQueryString(url, name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = url.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]);
        return null;
    },
    formatToFixedValue(val, num=2) {
        if(typeof(val) == 'number' && val) {
            return val.toFixed(num)
        } else {
            return val
        }
    },
    isTr() {
        let url = location.href
        let trWebsite = this.getQueryString(url, 'website')
        return trWebsite=='tur'
    },
    delay: (function () {
        let timer = 0
        return function (callback, ms) {
            clearTimeout(timer)
            timer = setTimeout(callback, ms)
        }
    })(),
    // 选中节点去重
    unique(nodes) {
        let res = [],
            obj = {}
        for (let i = 0; i < nodes.length; i++) {
            if (!obj[nodes[i].data.id]) {
                res.push(nodes[i])
                obj[nodes[i].data.id] = 1
            } else {
                obj[nodes[i].data.id]++
            }
        }
        return res
    },
     //判断对象是否是空值
      isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
      }

}
